import React from 'react';
//CSS
import styles from './NoItems.module.css';
//Components
//Data

type NoItemsProps = {
    textAlign?: 'top' | 'bottom';
    message?: string;
};

const NoItems = ({ message, textAlign }: NoItemsProps) => {
  return (
    <div className={`${styles.emptyContainer} ${textAlign === 'top' ? styles.top : styles.bottom}`}>
            <img src='/img/Resources/empty.svg' />
            <p>{message || "There are no items to display."}</p>  
          </div> 
  );
};

export default NoItems;